import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/ReportTypesService';
import {ReportType} from '../types';

/** Stripe epoch SECONDS to milliseconds; anything else (null, undefined) to undefined. */
const toMillis = (seconds?: number | null) =>
    typeof seconds === 'number' ? seconds * 1000 : undefined;

/**
 * FNP-1106: the detail view's half of the FNP-918 fix. Stripe hands back epoch
 * SECONDS; the shared timestamp formatter reads a bare number as MILLISECONDS.
 * Normalise ONCE, here, so the profile needs no `as unknown as string` cast —
 * the cast is what hid the wrong unit from the compiler.
 */
const normalise = (record?: ReportType): ReportType | undefined => record && {
    ...record,
    updatedMillis: toMillis(record.updated),
    dataAvailableStartMillis: toMillis(record.dataAvailableStart),
    dataAvailableEndMillis: toMillis(record.dataAvailableEnd),
};

export const useReportType = (reportTypeId?: string) => {

    const reportTypeQuery = useQuery({
        queryKey: ['reportType', reportTypeId],
        queryFn: () => fetch(reportTypeId!),
        enabled: !!reportTypeId,
        select: normalise,
    });

    return {
        record: reportTypeQuery.data,
        loading: reportTypeQuery.isLoading,
        fetchRecord: reportTypeQuery.refetch,
    };
};
